export default "__VITE_ASSET__Qzqw0_NG__"